/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Polyline, Tooltip } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import { getTrafficStatusMapV2 } from '../../../../state/selectors/trafficStatusMap.selector';
import { getTrafficStatusForMapV2 } from '../../../../features/trafficStatusMapSlice';
import { gradient, zoomLevel2PolylineWeight } from '../../../../utils/mapFunctions';

// function usePrevious(value) {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// }

function TrafficStatus(props) {
  const { zoomLevel, bounds } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // const payload = { zoomLevel, center, time: Date.now() };
  const { _northEast, _southWest } = bounds;
  let payloadV2 = {};
  if (_northEast && _northEast.lat) {
    payloadV2 = {
      NElat: _northEast.lat,
      NElng: _northEast.lng,
      WSlat: _southWest.lat,
      WSlng: _southWest.lng,
      zoom: zoomLevel,
    };
  }
  const trafficStatus = useSelector(getTrafficStatusMapV2);

  useEffect(() => {
    if (payloadV2 && payloadV2.NElat) {
      dispatch(getTrafficStatusForMapV2(payloadV2));
    }
  }, [bounds]);
    return (
      <>
        {trafficStatus.length > 0 &&
          trafficStatus.map((status) => {
            const firstPoint = [
              status.polyline.coordinates[0][1],
              status.polyline.coordinates[0][0],
            ];
            const endPoint = [
              status.polyline.coordinates[1][1],
              status.polyline.coordinates[1][0],
            ];
            return (
              <Polyline
                key={status._id}
                positions={[firstPoint, endPoint]}
                pathOptions={{
                  color: gradient(status.velocity / 60),
                  weight: zoomLevel2PolylineWeight(zoomLevel),
                }}
              >
                <Tooltip>
                  <p style={{ margin: 0 }}>{`${t('Velocity')}: ${
                    status.velocity
                  } km/h`}</p>
                  <p style={{ margin: 0 }}>{`${t('Source')}: ${
                    status.source
                  }`}</p>
                </Tooltip>
              </Polyline>
            );
          })}
      </>
    );
}
export default TrafficStatus;
